import { styled } from "@mui/material/styles";
import MuiBox from "@mui/material/Box";
import MuiTypography from "@mui/material/Typography";
import useThemeDetector from "hooks/useThemeDetector";
import { THEME_COLORS } from "constants/theme";
import mockChatData from "./mockChatData.json";
import { ThemedPhoneIcon ,ThemedBotIcon } from "assets/CXFIcons/Static";

const ChatContainer = styled(MuiBox)({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
  padding: "16px",
});

const Typography = styled(MuiTypography)(({ theme }) => ({
  color: THEME_COLORS[theme.palette.mode.toUpperCase()].PRIMARY_FONT,
}));

const SenderInfo = styled(MuiBox)(({ sender }) => ({
  display: "flex",
  justifyContent: sender === "bot" ? "flex-end" : "flex-start",
  alignItems: "center",
  gap: "6px",
  marginBottom: "4px",
}));

const MessageWrapper = styled(MuiBox)(({ sender }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: sender === "bot" ? "flex-end" : "flex-start",
}));

const MessageBubble = styled(MuiBox)(({ sender, theme }) => {
  const isDarkMode = theme.palette.mode === "dark";

  return {
    backgroundColor:
      sender === "bot" ? (isDarkMode ? "#EBE6FC" : "#F6F3FF") : isDarkMode ? "#EBFFF2" : "#F4FFF8",
    border: `0.5px solid ${
      sender === "bot" ? (isDarkMode ? "#A595D4" : "#E2D8FF") : isDarkMode ? "#92E8AD" : "#C6F6D5"
    }`,
    borderRadius: "8px",
    padding: "10px 14px",
    maxWidth: "75%",
  };
});

const MessageText = styled(MuiTypography)(() => ({
  fontSize: "14px",
  lineHeight: "1.5",
  color: THEME_COLORS.LIGHT.PRIMARY_FONT,
}));

const MessageMeta = styled(MuiBox)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "6px",
  fontSize: "12px",
  color: THEME_COLORS.LIGHT.PRIMARY_FONT,
  marginTop: "4px",
}));

const ConversationalLogs = () => {
  const { theme } = useThemeDetector();
  // const [chatStartTime, setChatStartTime] = useState(""); 
  // const [chatEndTime, setChatEndTime] = useState(""); 
  // const [assistantMessages, setAssistantMessages] = useState("");
  // const [userMessages, setUserMessages] = useState("");

  // const handleSetChatStartTime = (time) => {
  //   setChatStartTime(time);
  // }

  // const handleSetChatEndTime = (time) => {
  //   setChatEndTime(time);
  // }

  return (
    <ChatContainer>
      <div>
        <Typography
          variant="p"
          sx={{ fontSize: "12px", fontWeight: 400, display: "flex", justifyContent: "center" }}
        >
          {/* {new Date(chatStartTime).toLocaleString()} */}
          Friday, April 4, 2025 2:53 PM
        </Typography>
      </div>
      {mockChatData.map(({ id, sender, message, timestamp }) => (
        <MessageWrapper key={id} sender={sender}>
          <MessageBubble sender={sender} theme={theme}>
            <SenderInfo sender={sender}>
              {sender === "bot" ? (
                <>
                  <MessageMeta>{new Date(timestamp).toLocaleString()}</MessageMeta>
                  <ThemedBotIcon width="16px" height="14px" color="#1E283E" />
                </>
              ) : (
                <>
                  <ThemedPhoneIcon width="16px" height="14px" color="#1E283E" />
                  <MessageMeta>{new Date(timestamp).toLocaleString()}</MessageMeta>
                </>
              )}
            </SenderInfo>
            <MessageText>{message}</MessageText>
          </MessageBubble>
        </MessageWrapper>
      ))}
      <div>
        <Typography
          variant="p"
          sx={{ fontSize: "12px", fontWeight: 400, display: "flex", justifyContent: "center" }}
        >
          {/* Interaction ended: {new Date(chatEndTime).toLocaleString()} */}
          Interaction ended: Friday, April 4, 2025 2:54 AM
        </Typography>
      </div>
    </ChatContainer>
  );
};

export default ConversationalLogs;
